export const questionnaireScope = 'zdbQuestionnaire';
